import { cn } from "@/lib/cn";

function formatReadAt(dateStr: string) {
  return new Date(dateStr).toLocaleString("nb-NO", {
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
}

/**
 * Whether the customer has read the doctor's latest message in a dialog.
 * Thread-level: the backend stores one read timestamp per thread, so this says
 * "the newest doctor message is unread / was read at …", not per-message ticks.
 * Renders nothing for a thread that only holds the customer's own messages.
 */
export function ReadState({
  hasUnread,
  userReadAt,
  className,
}: {
  hasUnread: boolean;
  userReadAt: string | null;
  className?: string;
}) {
  if (hasUnread) {
    return (
      <span className={cn("whitespace-nowrap text-admin-warn-400", className)}>
        Ikke lest
      </span>
    );
  }
  if (!userReadAt) return null;

  return (
    <span className={cn("whitespace-nowrap text-admin-text-subtle", className)}>
      Lest {formatReadAt(userReadAt)}
    </span>
  );
}
